module.exports = __webpack_public_path__ + "static/media/kirgan.87b22835.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/SectionGenius/medias/kirgan.png
// module id = 232
// module chunks = 0